<template>
  <validation-observer ref="form" @keydown.enter="validate">
    <v-form>
      <v-row>
        <v-col>
          <validation-provider v-slot="{ errors }">
            <v-text-field
              hide-details='auto'
              v-model="numOrder"
              :error-messages="errors"
              :label="$t('order.numOrder')"
              required
              clearable
            >
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' sm='6'>
          <validation-provider :rules="lastName ? 'required':''" v-slot="{ errors }" :name="$t('subOrder.firstName')">
            <v-text-field
              v-model="firstName"
              hide-details='auto'
              :error-messages="errors"
              :label="$t('subOrder.firstName')"
              required
              clearable
            >
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols='12' sm='6'>
          <validation-provider :rules="firstName ? 'required':''" v-slot="{ errors }" :name="$t('subOrder.lastName')">
            <v-text-field
              v-model="lastName"
              hide-details='auto'
              :error-messages="errors"
              :label="$t('subOrder.lastName')"
              required
              clearable
            >
              <template v-slot:append-outer>
                <v-tooltip v-model="showFirstNameAndLastNameTooltip" top >
                  <template v-slot:activator="{ attrs }">
                    <v-btn
                        class="mt-1"
                        x-small
                        icon
                        v-bind="attrs"
                        @click="showFirstNameAndLastNameTooltip = !showFirstNameAndLastNameTooltip"
                        @mouseover="showFirstNameAndLastNameTooltip = true"
                        @mouseleave="showFirstNameAndLastNameTooltip = false"
                    >
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('searchForm.mandatoryFirstAndLastNames') }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <validation-provider rules="email" v-slot="{ errors }">
            <v-text-field
              v-model="email"
              hide-details='auto'
              :error-messages="errors"
              :label="$t('subOrder.email')"
              required
              clearable
            >
            </v-text-field>
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <vue-tel-input-vuetify
            id="phone_cell"
            v-model="phoneForm"
            :error-messages="phoneError"
            :placeholder="$t('searchForm.enterPhoneNumber')"
            class="mt-1"
            :label="$t('searchForm.phoneNumber')"
            mode="international"
            @input="updatePhone"
            clearable
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <date-filter
            v-model="dates"
            :clearable="true"
            :hide-details="true"
            :loading-data="loadingData"
            :placeholder="$t('subOrder.filterByDates')"
            text-field-append-icon="mdi-calendar"
            @resetDate="resetDate"
            @validateDate="validateDate"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <v-btn
            class="ma-2 text-uppercase"
            color="primary"
            outlined
            :disabled="disableValidate || loadingData"
            :loading="loadingData"
            @click="validate"
          >{{ $t("subOrder.validate") }}
          </v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </validation-observer>
</template>
<script>

import { ValidationProvider, ValidationObserver, extend} from 'vee-validate'
import {email, required} from "vee-validate/dist/rules"
import DateFilter from "@/components/DateFilter.vue";

extend("required", {
  ...required
});

extend("email", {
  ...email
});

export default {
  name: 'searchOrderForm',
  components: {
    DateFilter,
    "validation-provider": ValidationProvider,
    "validation-observer": ValidationObserver
  },
  props: {
    loadingData: {
      type: Boolean,
      default:  false
    }
  },
  data(){
    return {
      email: "",
      firstName: "",
      lastName: "",
      numOrder: "",
      phone: {
        number: "",
        prefix: ""
      },
      dates: [],
      previousDates: this.dates,
      showFirstNameAndLastNameTooltip: false,
      showFirstNameAndLastNameTooltipInterval: undefined,
      phoneError: [],
      phoneForm: ""
    }
  },
  methods: {
    validate () {
      this.$refs.form.validate().then(success => {
        if(success) {
          let sortedDates = []
          if(Array.isArray(this.dates) && this.dates.length > 1) {
            sortedDates = this.dates.sort((a, b) => {
              return new Date(a) - new Date(b)
            })
          }
          this.$emit('confirm', {
            email: this.email, firstName: this.firstName, lastName: this.lastName, numOrder: this.numOrder, phone: this.phone,
            dateFrom: sortedDates.length > 0 ? new Date(sortedDates[0]) : undefined,
            dateTo: sortedDates.length > 1 ? new Date(sortedDates[1]) : undefined
          })
        }
      })
    },
    validateDate () {
      if (this.dates.length > 0 && this.dates != this.previousDates) {
        this.previousDates = this.dates
        if(!this.disableValidate) {
          this.validate()
        }
      }
    },
    resetDate () {
      this.dates = []
      this.previousDates = this.dates
      if(!this.disableValidate) {
        this.validate()
      }
    },
    mandatoryValueIsInvalid(value){
      return [null, "", undefined].includes(value)
    },
    updatePhone (number, phone) {
      this.phone.prefix = phone.country.dialCode
      if (phone.isValid) {
        this.phoneError = ""
        // we use phone.number.e164 as there are no space unlike number
        this.phone.number = phone.number.e164
      } else{
        // if the input is empty we don't want to display the error message
        this.phoneError = number ? this.$t('searchForm.phoneError') : ""
        this.phone.number =  ""
      }
    },
  },
  computed: {
    disableValidate(){
      return this.mandatoryValueIsInvalid(this.numOrder) && this.mandatoryValueIsInvalid(this.email)
          && (this.mandatoryValueIsInvalid(this.lastName) ||  this.mandatoryValueIsInvalid(this.firstName))
          && (this.mandatoryValueIsInvalid(this.phone.number) || this.mandatoryValueIsInvalid(this.phone.prefix))
    },
  },
  watch: {
    showFirstNameAndLastNameTooltip(value) {
      if (value === true) {
        this.showFirstNameAndLastNameTooltipInterval = setInterval(() => {
          this.showFirstNameAndLastNameTooltip = false
        }, 2000)
      } else {
        clearInterval(this.showFirstNameAndLastNameTooltipInterval)
      }
    },
  }
}
</script>
